export const LOCALES = {
  es: {
    TITLE: '¿Deseas desactivar la ruta?',
    SUBTITLE: 'Consideraciones:',
    LIST_1:
      'Los usuarios asignados dejarán de visualizar esta ruta y sus cursos.',
    LIST_2:
      'Los usuarios que culminaron los cursos mantendrán visibles sus certificados.',
    LIST_3:
      'La estadísticas de la ruta permanecerán disponibles para los administradores, pero no podrán editar las opciones.',
    LIST_4: 'Puedes reactivar la ruta cuando lo necesites.',
    DEACTIVATE: 'Sí, desactivar',
    CANCEL: 'Cancelar',

    TITLE_2: '¿Deseas reactivar la ruta?',
    LIST_2_1: 'Los usuarios asignados volverán a visualizar la ruta.',
    LIST_2_2:
      'No se enviará una notificación para los usuarios asignados previamente, solo para los nuevos que se asignen luego de la reactivación.',
    ACTIVATE: 'Sí, reactivar',
  },
  pt: {
    TITLE: 'Deseja desativar a trilha?',
    SUBTITLE: 'Considerações:',
    LIST_1: 'Usuários atribuídos não verão mais esta trilha e seus percursos.',
    LIST_2:
      'Usuários que concluíram os cursos manterão seus certificados visíveis.',
    LIST_3:
      'As estatísticas de trilha permanecerão disponíveis para os administradores, mas eles não poderão editar as opções.',
    LIST_4: 'Você pode reativar a trilha sempre que precisar.',
    DEACTIVATE: 'Sim, desativar',
    CANCEL: 'Cancelar',

    TITLE_2: 'Deseja reativar a rota?',
    LIST_2_1: 'Os usuários atribuídos verão a trilha novamente.',
    LIST_2_2:
      'Uma notificação não será enviada para usuários atribuídos anteriormente, apenas para novos atribuídos após a reativação.',
    ACTIVATE: 'Sim, reativar',
  },
  en: {
    TITLE: 'Do you want to deactivate the route?',
    SUBTITLE: 'Considerations:',
    LIST_1: 'Assigned users will no longer see this route and its courses.',
    LIST_2:
      'Users who completed the courses will keep their certificates visible.',
    LIST_3:
      "The route statistics will remain available for administrators, but they won't be able to edit the options.",
    LIST_4: 'You can reactivate the route whenever needed.',
    DEACTIVATE: 'Yes, deactivate',
    CANCEL: 'Cancel',
    TITLE_2: 'Do you want to reactivate the route?',
    LIST_2_1: 'Assigned users will see the route again.',
    LIST_2_2:
      "A notification won't be sent to previously assigned users, only to new ones assigned after reactivation.",
    ACTIVATE: 'Yes, reactivate',
  },
};
